/**
 * Возврат фокуса для окон на Radix Dialog без DialogTrigger: Radix возвращает фокус
 * только своему Trigger, а наши окна открываются обычными кнопками. Элемент в фокусе
 * запоминается при открытии (Radix вызывает onOpenAutoFocus до переноса фокуса в окно)
 * и получает фокус обратно при закрытии и при размонтировании окна.
 */
import { useRef } from 'react';

export function useReturnFocus() {
	const opener = useRef<HTMLElement | null>(null);
	return {
		onOpenAutoFocus: () => {
			opener.current =
				document.activeElement instanceof HTMLElement ? document.activeElement : null;
		},
		onCloseAutoFocus: (event: Event) => {
			event.preventDefault();
			opener.current?.focus();
		},
	};
}
